import React from 'react';
import { Typography, Box } from '@mui/material';
import { SelectionCounterProps } from './mass-print-types';

/**
 * Displays the current selection count for mass printing FDC forms.
 * Shows "X of 10 selected" with visual indication when maximum is reached.
 *
 * @param props - Component props
 * @returns Rendered selection counter
 *
 * @example
 * ```tsx
 * <MassPrintSelectionCounter
 *   selectedCount={5}
 *   maxCount={10}
 * />
 * ```
 */
const MassPrintSelectionCounter: React.FC<SelectionCounterProps> = ({
  selectedCount,
  maxCount,
}) => {
  const isMaxReached = selectedCount >= maxCount;
  const hasSelection = selectedCount > 0;

  if (!hasSelection) {
    return null;
  }

  return (
    <Box
      sx={{ display: 'flex', alignItems: 'center', marginLeft: 2, flexDirection: 'row-reverse' }}
    >
      <Typography
        variant="body2"
        sx={{
          color: isMaxReached ? 'error.main' : 'text.secondary',
          fontWeight: isMaxReached ? 600 : 400,
        }}
      >
        {selectedCount} of {maxCount} selected
        {isMaxReached && ' (Maximum reached)'}
      </Typography>
    </Box>
  );
};

export default MassPrintSelectionCounter;
